export const details = [
  'Электронная регистрация',
  'Электронные подписи для всех участников сделки',
  'Сопровождение персональным помощником на всех этапах',
  'Удостоверение банком участников сделки',
  'Оплата госпошлины',
];
